export const productType = {
  HELOC: 'HELOC',
};

export const decision = {
  DECLINE: 'DECLINE',
  ASSET_DEPLETION: 'ASSET_DEPLETION',
};
